<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight] current="Covered Item Details"></fury-breadcrumbs>
    </fury-page-layout-header>
  </fury-page-layout>
  
  <fury-page-layout-content cdkDropListGroup
                            fxLayout="row"
                            fxLayout.lt-sm="column"
                            fxLayoutGap="24px">

                            <fury-card [@fadeInUp] class="basic-forms" fxFlex="auto">
                              <fury-card-header>
                                <div class="heading">
                                  <fury-card-header-heading>Item list</fury-card-header-heading>
                                  <button mat-button class="can-button" (click)="back()">Back</button>
                                </div>
                                
                              </fury-card-header>
                              <fury-card-content>
                                <div class="table-responsive" style="text-align: center;" *ngIf="dataSource?.data?.length === 0">
                                  There is no assigned item
                                </div>
                                  <table [dataSource]="dataSource" mat-table matSort *ngIf="dataSource && dataSource?.data?.length !== 0">
                                    <ng-container matColumnDef="title">
                                      <th mat-header-cell *matHeaderCellDef>Item Name</th>
                                      <td mat-cell *matCellDef="let element">
                                        {{element['title'] | uppercase}}
                                      </td>
                                    </ng-container>
                                    <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                                    <tr *matRowDef="let row; columns: visibleColumns;" class="clickable route-animations-elements" mat-row></tr>
                                  </table>
                              </fury-card-content>
                            </fury-card>
  </fury-page-layout-content>  
  
